import * as R from "ramda";
import { createHandlers } from "redux-mvc";
import { NAMESPACE } from "./constants";

const iniState = {
  loading: true,
  sessionId: null,
  sessionRecordId: null,
  customFields: {},
  translatedValues: [],
  type: "",
  recordTypeId: null,
  editingFieldId: "",
  languageModalIsOpen: null,
  selectedTranslatedFieldId: null,
  updatedLanguageValues: {}
};

const model = createHandlers({
  iniState,
  reducers: {
    init: R.identity,
    showSelectFieldsModal: R.identity,
    onEdit: R.identity,
    saveLanguageValues: R.identity,
    edit: (_, { payload: { id } }) => ({
      editingFieldId: id
    }),
    updateValue: ({ values }, { payload: { id, value } }) => ({
      editingFieldId: "",
      customFields: {
        values: {
          ...values,
          [id]: value
        }
      }
    }),
    updateTranslatedValue: (
      state,
      { payload: { fieldId, language, value } }
    ) => {
      return {
        updatedLanguageValues: {
          ...state.updatedLanguageValues,
          [fieldId]: state.updatedLanguageValues[fieldId]
            ? {
                ...state.updatedLanguageValues[fieldId],
                [language]: value
              }
            : {
                [language]: value
              }
        }
      };
    }
  },
  namespace: NAMESPACE
});

const { actions, getters } = model;

export { actions, getters };

export default model;
